import axios from "axios";

export default async function login(username, password){
    const res =  await axios.post("/login", {username, password});
    return res.data;
}